import React from 'react';
import Manual from '../Manual';
import Provider from '../Provider';
import { checkModalOnlySubscription } from '../../helper';
import AlertComponent from '../../../../../../../../components/Alert';

const SwitchFields = (props) => {
  // eslint-disable-next-line react/prop-types
  const { form: { mode }, modal } = props
  const isSubscription = checkModalOnlySubscription(modal)

  if (mode) {
    return <Provider {...props} />
  }

  /*
    Задача: https://www.notion.so/perfectpanel/Subscriptions-x16-PR-42-373c46983d37459285899e74621ebee1
    Скрываем все поля только для Subscription услуги (type = 100) с типом Manual
    Для Subscription reselling (type = 101) - оставляем поля
   */
  if (isSubscription) {
    return <AlertComponent type="warning" text="<b>Note</b>: Orders created from user subscriptions will need to be fulfilled on your own." />
  }

  return <Manual {...props} />
}

export default SwitchFields;
